module.exports = __webpack_public_path__ + "img/button-home4.94c40ce8.jpeg";